/* eslint-disable arrow-body-style */
import http from "./utils";
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { mockPrefix, prefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken; 

export const getKeyOpinionsRisingTopic: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
  urlParams?: string,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
  urlParams,
) => {
  return http({
    url: `${prefix}/overview/rising_topic?${urlParams}`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getKeyOpinionsRisingKeyword: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
  urlParams?: string,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c: any) => {},
  urlParams,
) => {
  return http({
    url: `${prefix}/overview/rising_keyword?${urlParams}`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getKeyOpinionHighGameGPTReport: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
) => Promise<any> = (payload, cancelTokenFunc = (c: any) => {}) => {
  return http({
    url: `${prefix}/overview/high_game_gpt_report`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};
